<i class="fad fa-circle-dot text-{{bot.botServiceId ? 'danger' : 'warning'}}"
    placement="{{direction}}"
    [popover]="updateDB"
    containerClass="bots-db-popover"
    #pop="bs-popover"
    triggers="mouseenter"
    [outsideClick]="true"></i>
<ng-template #updateDB>
    <div class="popover-buttons" (mouseleave)="pop.hide();">
        <table class="m-0" *ngIf="bot.botServiceId">
            <thead>
                <tr>
                    <th colspan="3">{{'Newer service available' | translate}}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><span class="badge badge-danger">{{ "Current" | translate }}</span></td>
                    <td><span [innerHTML]="formatedGDB(bot.currentBotService)"></span></td>
                    <td></td>
                </tr>
                <tr>
                    <td><span class="badge badge-success">{{ "Latest" | translate }}</span></td>
                    <td>
                        <span *ngIf="!showSelector" [innerHTML]="formatedGDB(bot.latestBotService?.name)"></span>
                        <search-services
                            class="w-100 full-w"
                            *ngIf="bot && showSelector"
                            (changeValue)="changeService($event)"
                            [items]="muleServices"
                            [selected]="bot.botServiceId"
                            [formatGDB]="true"
                            [placeholder]="'Select remote database' | translate">
                        </search-services>
                        <i *ngIf="loading" class="fad fa-spinner-third fa-spin"></i>
                    </td>
                    <td>
                        <i *ngIf="!showSelector" (click)="loading = !loading; showSelector = !showSelector;" placement="left" tooltip="{{'Select another database' | translate}}" class="far fa-pencil mr-2 btn-xs btn-bordered btn-icon simple-icon"></i>
                        <i *ngIf="showSelector" (click)="loading = !loading; showSelector = !showSelector;" class="far fa-times mr-2 btn-xs btn-bordered btn-icon simple-icon"></i>
                        <button *ngIf="!showSelector" (click)="updateBot(); pop.hide();" class="btn btn-xs btn-primary-extra-light text-uppercase">{{ "Update database" | translate }}</button>
                    </td>
                </tr>
            </tbody>
        </table>
        <table class="m-0" *ngIf="!bot.botServiceId">
            <thead>
                <tr>
                    <th colspan="3">{{'No service yet' | translate}}</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><span class="badge badge-warning">{{ "Select database" | translate }}</span></td>
                    <td>
                        <span *ngIf="!showSelector" (click)="loading = !loading; showSelector = !showSelector;">{{'No database selected' | translate}}</span>
                        <search-services
                            class="w-100 full-w"
                            *ngIf="bot && showSelector"
                            (changeValue)="changeService($event)"
                            [items]="muleServices"
                            [selected]="bot.botServiceId"
                            [formatGDB]="true"
                            [placeholder]="'Select remote database' | translate">
                        </search-services>
                        <i *ngIf="loading" class="fad fa-spinner-third fa-spin"></i>
                    </td>
                    <td>
                        <i *ngIf="!showSelector" (click)="loading = !loading; showSelector = !showSelector;" placement="left" tooltip="{{'Select another database' | translate}}" class="far fa-pencil mr-2 btn-xs btn-bordered btn-icon simple-icon"></i>
                        <i *ngIf="showSelector" (click)="loading = !loading; showSelector = !showSelector;" class="far fa-times mr-2 btn-xs btn-bordered btn-icon simple-icon"></i>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
  </ng-template>
